(() => {
  const welcome = document.querySelector('[data-sh-brand-welcome]');
  if (!welcome) return;

  const body = document.body;
  const choices = Array.from(welcome.querySelectorAll('[data-sh-welcome-choice]'));
  const closeButton = welcome.querySelector('[data-sh-welcome-close]');
  const params = new URLSearchParams(window.location.search);
  const selectionArrival = params.get('brand_welcome') === 'selected';
  const forcePreview = params.get('brand_welcome') === '1';
  const publishedTheme = body.dataset.shThemeRole === 'main' || body.dataset.shThemeRole === 'live';
  const storageKey = 'naturalistic-brand-welcome-v2';
  const choiceLifetime = 24 * 60 * 60 * 1000;

  const rememberChoice = () => {
    if (!publishedTheme) return;

    try {
      window.localStorage.setItem(storageKey, String(Date.now() + choiceLifetime));
    } catch (error) {
      // Storage can be unavailable in privacy-focused browsers; the chooser still works.
    }
  };

  const hasRecentChoice = () => {
    if (!publishedTheme) return false;

    try {
      const savedExpiry = window.localStorage.getItem(storageKey);
      // v1 stored a 30-day expiry. Preserve its original choice time but apply
      // the new 24-hour window, so existing visitors do not retain 30 days.
      const expiresAt = savedExpiry == null
        ? Number(window.localStorage.getItem('naturalistic-brand-welcome-v1')) - 29 * choiceLifetime
        : Number(savedExpiry);
      return Number.isFinite(expiresAt) && expiresAt > Date.now();
    } catch (error) {
      return false;
    }
  };

  const removeSelectionParameter = () => {
    params.delete('brand_welcome');
    const cleanUrl = `${window.location.pathname}${params.toString() ? `?${params}` : ''}${window.location.hash}`;
    window.history.replaceState(null, '', cleanUrl);
  };

  if (selectionArrival) {
    rememberChoice();
    removeSelectionParameter();
    return;
  }

  // Product, collection and cart visitors have already chosen a shopping path.
  // Keep the persistent brand tabs available without covering their destination.
  const shoppingPage = ['product', 'collection', 'list-collections', 'cart', 'search'].includes(document.documentElement.dataset.shPage);
  if (shoppingPage && !forcePreview) return;

  if ((window.Shopify && window.Shopify.designMode && !forcePreview) || (!forcePreview && hasRecentChoice())) {
    return;
  }

  const madeInert = new Set();
  const isolateDialog = () => {
    for (const sibling of body.children) {
      if (sibling === welcome || sibling.contains(welcome) || sibling.inert) continue;
      sibling.inert = true;
      madeInert.add(sibling);
    }
  };
  const backgroundObserver = new MutationObserver(isolateDialog);
  const focusable = () => Array.from(welcome.querySelectorAll('a[href], button:not([disabled])'));
  const keepFocusInDialog = (event) => {
    if (!welcome.hidden && !welcome.contains(event.target)) closeButton.focus();
  };

  const closeWelcome = () => {
    backgroundObserver.disconnect();
    document.removeEventListener('focusin', keepFocusInDialog);
    madeInert.forEach((sibling) => { sibling.inert = false; });
    madeInert.clear();
    welcome.hidden = true;
    body.classList.remove('sh-brand-welcome-open');
    window.shAccessibility?.focusContent();
  };

  welcome.hidden = false;
  body.classList.add('sh-brand-welcome-open');

  window.requestAnimationFrame(() => {
    if (welcome.hidden) return;
    closeButton.focus({ preventScroll: true });
    isolateDialog();
    backgroundObserver.observe(body, { childList: true });
    document.addEventListener('focusin', keepFocusInDialog);
  });

  closeButton.addEventListener('click', () => {
    rememberChoice();
    closeWelcome();
  });

  choices.forEach((choice) => {
    choice.addEventListener('click', (event) => {
      if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      rememberChoice();
      closeWelcome();
    });
  });

  welcome.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      rememberChoice();
      closeWelcome();
      return;
    }
    const controls = focusable();
    if (event.key !== 'Tab' || controls.length < 2) return;

    const firstChoice = controls[0];
    const lastChoice = controls[controls.length - 1];

    if (event.shiftKey && document.activeElement === firstChoice) {
      event.preventDefault();
      lastChoice.focus();
    } else if (!event.shiftKey && document.activeElement === lastChoice) {
      event.preventDefault();
      firstChoice.focus();
    }
  });
})();
